import { render, staticRenderFns } from "./CurveShape.vue?vue&type=template&id=2f282228&scoped=true&"
import script from "./CurveShape.vue?vue&type=script&lang=js&"
export * from "./CurveShape.vue?vue&type=script&lang=js&"
import style0 from "./CurveShape.vue?vue&type=style&index=0&id=2f282228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f282228",
  null
  
)

export default component.exports